import { useContext } from 'react';
import { useLazyQuery } from 'react-apollo';
import { useShopConfig } from './useShopConfig';
import { usePagination } from '../components/Pagination/PaginationProvider';
import SortOrderContext from '../components/SortOrder/SortOrderContext';
export const useRoutePreload = () => {
    var _a, _b, _c;
    const config = useShopConfig();
    const routeQuery = (_b = (_a = config === null || config === void 0 ? void 0 : config.preload) === null || _a === void 0 ? void 0 : _a.routeQuery) !== null && _b !== void 0 ? _b : null;
    const preloadComponents = (_c = config === null || config === void 0 ? void 0 : config.preload) === null || _c === void 0 ? void 0 : _c.preloadComponents;
    const pagination = usePagination();
    const sortOrderState = useContext(SortOrderContext);
    const [runPreloadRouteQuery] = useLazyQuery(routeQuery, {
        errorPolicy: 'all',
        partialRefetch: true,
        context: { useApolloNetworkStatus: false }
    });
    const preload = ({ pathname, preloadRoute = true, routeType, variables = {} }) => {
        // If the path targets an external link, it does not fetch
        if (!preloadRoute || pathname.charAt(0) !== '/') {
            return;
        }
        routeQuery &&
            runPreloadRouteQuery({
                variables: Object.assign({ path: pathname, first: (pagination === null || pagination === void 0 ? void 0 : pagination.perPage) || 24, offset: (pagination === null || pagination === void 0 ? void 0 : pagination.offset) || 0, orderBy: (sortOrderState === null || sortOrderState === void 0 ? void 0 : sortOrderState.sortOrder) || null, orderByDirection: (sortOrderState === null || sortOrderState === void 0 ? void 0 : sortOrderState.direction) || 'DESCENDING', filters: {
                        listFilters: [],
                        rangeFilters: [],
                        booleanFilters: [],
                        multiListFilters: []
                    } }, variables)
            });
        preloadComponents &&
            preloadComponents[routeType] &&
            preloadComponents[routeType].forEach((component) => {
                component.preload();
            });
    };
    return { preload };
};
//# sourceMappingURL=useRoutePreload.js.map